import enumLabel from "../../../utils/labels/enumLabel";
import { ConditionValueSelectorComponent } from "./ConditionForm";
import {
  BillingRuleConditionParameter,
  BillingRuleConditionParameterType,
} from "../../../graphql/generated";
import FuelCostAreaSelect from "./value-selectors/FuelCostAreaSelect";
import FuelCostBasisSelect from "./value-selectors/FuelCostBasisSelect";
import FuelCostEffectiveDaySelect from "./value-selectors/FuelCostEffectiveDaySelect";
import FuelCostPeriodSelect from "./value-selectors/FuelCostPeriodSelect";

const ConditionValueSelectorComponentByTarget: {
  [key in BillingRuleConditionParameterType]: ConditionValueSelectorComponent | null;
} = {
  [BillingRuleConditionParameterType.FuelCostArea]: FuelCostAreaSelect,
  [BillingRuleConditionParameterType.FuelCostPeriod]: FuelCostPeriodSelect,
  [BillingRuleConditionParameterType.FuelCostEffectiveDay]:
    FuelCostEffectiveDaySelect,
  [BillingRuleConditionParameterType.FuelCostBasis]: FuelCostBasisSelect,
};

const conditionParameterLabels: Partial<
  Record<BillingRuleConditionParameterType, string>
> = {
  [BillingRuleConditionParameterType.FuelCostArea]: "Fuel Cost Area",
  [BillingRuleConditionParameterType.FuelCostPeriod]: "Period",
  [BillingRuleConditionParameterType.FuelCostEffectiveDay]: "Effective Day",
  [BillingRuleConditionParameterType.FuelCostBasis]: "Basis",
};

type ConditionParameterFormProps = {
  conditionParameter: BillingRuleConditionParameter;
  onChange: (conditionParameter: BillingRuleConditionParameter) => void;
};

const ConditionParameterForm = ({
  conditionParameter,
  onChange,
}: ConditionParameterFormProps) => {
  const ValueSelectorComponent =
    ConditionValueSelectorComponentByTarget[conditionParameter.type];
  if (!conditionParameter.type || !ValueSelectorComponent) {
    return null;
  }

  return (
    <ValueSelectorComponent
      label={
        conditionParameterLabels[conditionParameter.type] ||
        enumLabel(conditionParameter.type)
      }
      value={conditionParameter.value}
      onChange={(value) =>
        onChange({
          ...conditionParameter,
          value,
        })
      }
    />
  );
};

export default ConditionParameterForm;
